import _regeneratorRuntime from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "D:/projectMenu/feedback/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-0e04293a"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  "class": "name"
};
import Activity from '@/common/components/Activity.vue';
import { fileUploader } from '@/common/util/fileUploader';
import { useNavigation } from '@/common/util/navigation';
import { useLoading } from '@/common/util/useLoading';
import { validator } from '@/common/util/validator';
import { postApiFeedbackReply } from '@/service/api';
import { EnumContactType } from '@/util/dict';
import AuthUploader from '@/common/components/AuthUploader.vue';
import { reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { feedbackInfoAction } from '@/util/event';
import { t } from '@/i18n';
export default /*#__PURE__*/_defineComponent({
  setup: function setup(__props) {
    var _useNavigation = useNavigation(),
      toBack = _useNavigation.toBack,
      toReplace = _useNavigation.toReplace;
    var route = useRoute();
    var _useLoading = useLoading(),
      _useLoading2 = _slicedToArray(_useLoading, 2),
      loading = _useLoading2[0],
      handler = _useLoading2[1];
    var fieldRef = ref();
    var needScroll = ref(false);
    var files = ref([]);
    var isShowUpload = window.isShowUpload;
    console.log(isShowUpload, 'isShowUploadSub');
    var originHeight = window.innerHeight;
    var onFocus = function onFocus() {
      setTimeout(function () {
        var top = fieldRef.value.$el.getBoundingClientRect().top;
        window.scrollTo({
          top: top + 200,
          behavior: 'smooth'
        });
      }, 100);
    };
    window.addEventListener("resize", function () {
      var newHeight = window.innerHeight;
      // 键盘弹起
      if (newHeight < originHeight) {
        var _fieldRef$value;
        console.log('键盘弹起');
        if (needScroll.value && (_fieldRef$value = fieldRef.value) !== null && _fieldRef$value !== void 0 && _fieldRef$value.$el) {
          setTimeout(function () {
            fieldRef.value.$el.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
            needScroll.value = false;
          }, 50);
        }
      }
    });
    // openId: '13ca2ac66c094ef198d96d4af3ee7618',
    var state = reactive({
      appId: window.appId,
      id: Number(route.params.id),
      userName: window.nickname,
      openId: window.openid,
      appVersion: window.clientVersion,
      phoneModel: window.clientInfo,
      os: window.os,
      osVersion: window.osVersion,
      netType: window.netType,
      feedbackTypeId: 0,
      content: '',
      url: '',
      contactType: EnumContactType.Mobile,
      contact: '',
      ua: window.navigator.userAgent,
      extend: window.customInfo
    });
    var toSubmit = function toSubmit() {
      handler(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var urls;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return validator(state, {
                content: [['required', t('contentRequired')], ['min:5', t('contentMin5')]]
              });
            case 2:
              _context.next = 4;
              return fileUploader(files.value.map(function (file) {
                return file.file;
              }));
            case 4:
              urls = _context.sent;
              state.url = urls.join(',');
              _context.next = 8;
              return postApiFeedbackReply(state);
            case 8:
              feedbackInfoAction.emit('refresh');
              toReplace('/feedback/info/successsubimit');
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee);
      })));
    };
    return function (_ctx, _cache) {
      var _component_van_field = _resolveComponent("van-field");
      var _component_FeedbackFormItem = _resolveComponent("FeedbackFormItem");
      var _component_ScreenScrollView = _resolveComponent("ScreenScrollView");
      var _component_van_button = _resolveComponent("van-button");
      var _component_TransitionRouteView = _resolveComponent("TransitionRouteView");
      return _openBlock(), _createBlock(Activity, {
        "class": "FeedbackInfoSubmit"
      }, {
        "default": _withCtx(function () {
          return [_createElementVNode("div", {
            "class": "close",
            onClick: _cache[0] || (_cache[0] =
            //@ts-ignore
            function () {
              return _unref(toBack) && _unref(toBack).apply(void 0, arguments);
            })
          }), _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('appendReply')), 1), _createVNode(_component_ScreenScrollView, null, {
            "default": _withCtx(function () {
              return [_createVNode(_component_FeedbackFormItem, {
                title: _unref(t)('replyRequired')
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(_component_van_field, {
                    onFocus: onFocus,
                    ref: function ref(_value, _refs) {
                      _refs['fieldRef'] = _value;
                      fieldRef.value = _value;
                    },
                    "class": "custom-field",
                    type: "textarea",
                    placeholder: _unref(t)('feedbackDescPlaceholder'),
                    modelValue: _unref(state).content,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                      return _unref(state).content = $event;
                    })
                  }, null, 8, ["placeholder", "modelValue"])];
                }),
                _: 1
              }, 8, ["title"]), _unref(isShowUpload) ? (_openBlock(), _createBlock(_component_FeedbackFormItem, {
                key: 0,
                title: _unref(t)('uploadImagesMax3')
              }, {
                "default": _withCtx(function () {
                  return [_createVNode(AuthUploader, {
                    value: files.value,
                    "onUpdate:value": _cache[2] || (_cache[2] = function ($event) {
                      return files.value = $event;
                    }),
                    "max-count": 3
                  }, null, 8, ["value"])];
                }),
                _: 1
              }, 8, ["title"])) : _createCommentVNode("", true)];
            }),
            _: 1
          }), _createVNode(_component_van_button, {
            "class": "button",
            onClick: toSubmit,
            loading: _unref(loading),
            block: ""
          }, {
            "default": _withCtx(function () {
              return [_createTextVNode(_toDisplayString(_unref(t)('submit')), 1)];
            }),
            _: 1
          }, 8, ["loading"]), _createVNode(_component_TransitionRouteView)];
        }),
        _: 1
      });
    };
  }
});